import React from 'react';
import { Url } from '@wix/da-url';
export const FolderLink = ({ folder, children, className, onClick })=>/*#__PURE__*/ React.createElement("a", {
        onClick: onClick,
        className: className,
        href: Url.userGalleryLink({
            username: folder.owner.username,
            gallectionType: folder.type,
            folderId: folder.folderId,
            folderName: folder.name
        })
    }, children);
FolderLink.displayName = 'FolderLink';
export default FolderLink;
